import { makeStyles } from '@material-ui/core';

export const globalStyles = makeStyles({
  '@global': {
    '.box-shadow': {
      boxShadow: '0px 16px 40px rgba(171, 182, 200, 0.39)',
    },
    '::-webkit-scrollbar': {
      width: 4,
      height: 8,
      hight: '20%',
      background: '#C4C4C4',
      borderRadius: 6,
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: '#333',
      borderRadius: 6,
    },
  },
  
});
